import React from 'react';
import {
    Box,
    Flex,
    IconButton,
    Text,
} from '@chakra-ui/react';
import { HiMenuAlt2 } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';

interface NavbarProps {
    onOpen: () => void;
    title?: string;
}

const Navbar = ({ onOpen, title }: NavbarProps) => {
    const { t } = useTranslation('common');

    return (
        <Flex
            px={4}
            height="16"
            alignItems="center"
            bg="#1b73e8"
            borderBottomWidth="1px"
            borderBottomColor="rgba(255,255,255,0.12)"
            justifyContent="space-between"
            display={{ base: 'flex', lg: 'none' }}
            position="sticky"
            top={0}
            zIndex={99}
        >
            <IconButton
                variant="ghost"
                onClick={onOpen}
                aria-label="open menu"
                icon={<HiMenuAlt2 size={22} />}
                color="rgba(255,255,255,0.6)"
                _hover={{ bg: "rgba(255,255,255,0.06)", color: "white" }}
            />

            <Flex align="center" gap="8px">
                {/* Logo mark */}
                <Box
                    w="26px" h="26px"
                    borderRadius="6px"
                    bg="rgba(255,255,255,0.20)"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    boxShadow="0 0 14px rgba(99,102,241,0.4)"
                >
                    <Text fontSize="12px" fontWeight={900} color="white" lineHeight={1}>I</Text>
                </Box>
                <Text
                    fontSize="15px"
                    fontWeight={700}
                    color="white"
                    letterSpacing="0.01em"
                >
                    {title || t('mainName')}
                </Text>
            </Flex>

            {/* Spacer for balance */}
            <Box w="40px" />
        </Flex>
    );
};

export default Navbar;
